import { Injectable } from '@angular/core';

/** Service que valida os acessos e execuções de funcionalidades dos recursos de campanhas */
@Injectable({
    providedIn: 'root'
})
export class RecursoCampanhaAuthGuardService {

    /** Verifica se pode editar um recurso de campanha */
    canEdit(): boolean {
        return true;
    }

    /** Verifica se pode excluir um recurso de campanha */
    canDelete(): boolean {
        return true;
    }
}
